import { createReducer } from '../modules/helpers';
import { ActionTypes } from '../literals';
import { UserState, Status } from '../types';

export const userState = {
  isAuthenticated: false,
  status: Status.IDLE,
};

export default {
  user: createReducer<UserState>(
    {
      [ActionTypes.USER_LOGIN_REQUEST]: draft => {
        draft.status = Status.RUNNING;
      },
      [ActionTypes.USER_LOGIN_SUCCESS]: draft => {
        draft.isAuthenticated = true;
        draft.status = Status.READY;
      },
      [ActionTypes.USER_LOGOUT_REQUEST]: draft => {
        draft.status = Status.RUNNING;
      },
      [ActionTypes.USER_LOGOUT_SUCCESS]: draft => {
        draft.isAuthenticated = false;
        draft.status = Status.IDLE;
      },
    },
    userState,
  ),
};
